import { styled } from "@linaria/react"

import { Vertical } from "@/components/Flex.ts"
import * as textStyles from "@/styles/textStyles.ts"

export const FormFieldStyles = {
  Container: styled(Vertical)`
    align-items: flex-start;
    gap: 8px;

    width: 100%;
  `,

  Label: styled.div`
    ${textStyles.smallFontSize};
    ${textStyles.breakWord};

    color: var(--text-color);
    font-weight: 600;
  `,

  Description: styled.div`
    ${textStyles.smallFontSize};
    ${textStyles.breakWord};

    color: var(--secondary-text-color);
  `,

  InputContainer: styled.div`
    width: 100%;
  `,

  Error: styled.div`
    ${textStyles.smallFontSize};
    ${textStyles.breakWord};

    color: var(--error-color);
  `
}
